import { useState, useEffect } from "react";

import DynamicSelectInput from "../Select-Input/SelectInput";

import { fetchActiveCallStages } from "./DynamicCallStageMapping";

import { toCapitalize } from "../Common-Function/CommonFunctions";

import CALL_STAGE_COLORS from "../constants/stageColors";
import DynamicMultipleSelectCheckmarks from "../../Components/Multiple-Select-Checkmarks/MultipleSelectCheckmarks";

function DynamicCallStage({
  options = [],
  onChange = () => {},
  value = "",
  name = "",
  defaultOption = "Select",
  label = "",
  required = false,
  error = false,
  errorMessage = "",
  labelKey = "title",
  selectStyle = {
    fontFamily: "Satoshi",
    fontSize: "15px",
    fontWeight: 500,
    color: "var(--header__color)",
    borderRadius: "12px",
  },
  wrapperStyle = {},
  selectSx = {},
  labelStyle = {},
  menuWidth = 300,
  onBlur = () => {},
  enableTooltip = false,
  menuProps = {},
  clearable = false,
  disabled = false,
  defaultOptionStyle = {},
  isMultiselect = false,
}) {
  const [callStageOptions, setCallStageOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchCallStages = async () => {
    setIsLoading(true);

    try {
      const stages = await fetchActiveCallStages();

      const stageOptions = stages
        .filter((stage) => stage?.name)
        .map((stage) => ({
          title: toCapitalize(stage.name),
          value: stage.system_key,
        }));

      setCallStageOptions(stageOptions);
    } catch (error) {
      console.error("Error fetching call stages:", error);
      setCallStageOptions([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCallStages();
  }, []);

  return (
    <div className={isMultiselect ? "dynamic-call-stage-multiselect" : undefined}>
      {isMultiselect && (
        <style>{`
          .dynamic-call-stage-multiselect {
            position: relative;
            width: 100%;
            min-width: 0;
          }
          .dynamic-call-stage-multiselect .dropdown-container {
            position: relative;
            width: 100%;
            min-width: 0;
          }
          .dynamic-call-stage-multiselect .dropdown-textfield,
          .dynamic-call-stage-multiselect .dropdown-textfield input,
          .dynamic-call-stage-multiselect input.dropdown-textfield {
            border-radius: 999px !important;
            box-sizing: border-box;
          }
          .dynamic-call-stage-multiselect .dropdown-menu {
            left: auto !important;
            right: 0 !important;
            width: min(420px, calc(100vw - 24px)) !important;
            max-width: calc(100vw - 24px) !important;
            box-sizing: border-box;
            z-index: 1500;
          }
        `}</style>
      )}
      {!isMultiselect ? (
        <DynamicSelectInput
          options={callStageOptions}
          onChange={onChange}
          value={value}
          name={name}
          defaultOption={defaultOption}
          label={label}
          required={required}
          error={error}
          errorMessage={errorMessage}
          labelKey={labelKey}
          selectStyle={selectStyle}
          wrapperStyle={wrapperStyle}
          selectSx={selectSx}
          labelStyle={labelStyle}
          menuWidth={menuWidth}
          onBlur={onBlur}
          enableTooltip={enableTooltip}
          menuProps={menuProps}
          clearable={clearable}
          disabled={disabled || isLoading}
          defaultOptionStyle={defaultOptionStyle}
        />
      ) : (
        <DynamicMultipleSelectCheckmarks
          options={callStageOptions}
          onChange={onChange}
          value={value}
          name={name}
          placeholder={defaultOption}
          label={label}
          required={required}
          error={error}
          errorMessage={errorMessage}
          labelKey={labelKey}
          valueKey="value"
          selectStyle={selectStyle}
          wrapperStyle={wrapperStyle}
          selectSx={selectSx}
          labelStyle={labelStyle}
          menuWidth={menuWidth}
          onBlur={onBlur}
          enableTooltip={enableTooltip}
          menuProps={menuProps}
          clearable={clearable}
          disabled={disabled || isLoading}
          defaultOptionStyle={defaultOptionStyle}
          resetSearchTerm
        />
      )}
    </div>
  );
}

export default DynamicCallStage;
